import { Box } from "@mui/material";
import React from "react";

import stageScan from "../images/StageScan.jpg";
import fourtet from "../images/fourtet.jpeg";
import daisy from "../images/DaisyField.jpeg";
import butter from "../images/Butterfly.jpeg";
import winter from "../images/WinterSun.jpeg";
import wimbledon from "../images/Wimbledon.jpeg";
import bird from "../images/TheEarlyBird.jpg";
import metro from "../images/Metro.jpg";
import paris from "../images/Paris.jpg";
import guildford from "../images/GuildfordTown.png";

export default function HomeTab() {
  return (
    <>
      <center>
        <img src={stageScan} alt="Stage of Life" width="50%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={guildford} alt="Guildford Town" width="45%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={daisy} alt="Daisy" width="60%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={winter} alt="WinterSun" width="45%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={metro} alt="Metro" width="55%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={wimbledon} alt="Wimbledon" width="65%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={bird} alt="EarlyBird" width="55%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={fourtet} alt="AllyPally" width="70%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={paris} alt="Paris" width="55%" />
      </center>

      <Box sx={{ height: 70, width: "100%" }} />

      <center>
        <img src={butter} alt="Changes" width="35%" />
      </center>
    </>
  );
}
